import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";

// ----------------------------------------------------------------------------
// Service Worker kill switch
// ----------------------------------------------------------------------------
// The previous PWA service worker aggressively cached the frontend shell and
// static assets, which caused deployments to fail to reach real users (they
// kept seeing stale content). We now forcibly UNREGISTER any service worker
// and clear all cache storage so the browser always fetches the latest build
// from the network. The `/service-worker.js` file itself has also been
// replaced with a self-destructing stub for any browser that still fetches
// the old path before this JS executes.
if ('serviceWorker' in navigator) {
  navigator.serviceWorker.getRegistrations().then((regs) => {
    regs.forEach((r) => r.unregister().catch(() => {}));
  }).catch(() => {});
}
if (typeof caches !== 'undefined' && caches.keys) {
  caches.keys().then((names) => {
    names.forEach((n) => caches.delete(n).catch(() => {}));
  }).catch(() => {});
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
